import { render } from "./NavEntryEmpty.vue?vue&type=template&id=d37a4fc0"
import script from "./NavEntryEmpty.vue?vue&type=script&lang=js"
export * from "./NavEntryEmpty.vue?vue&type=script&lang=js"
script.render = render

export default script